import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ModVersionState {
  modVersion: number;
}

const initialState: ModVersionState = {
  modVersion: 0,
};

const modVersionSlice = createSlice({
  name: "modVersion",
  initialState,
  reducers: {
    setModCSPDCLVersion: (state, action: PayloadAction<number>) => {
      state.modVersion = action.payload;
    },
    clearModVersion: (state) => {
      state.modVersion = 0;
    },
  },
});

export const { setModCSPDCLVersion, clearModVersion } = modVersionSlice.actions;
export default modVersionSlice.reducer;
